"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSwitch = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/styles");
var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));
var _Switch = _interopRequireDefault(require("@material-ui/core/Switch"));
var _excluded = ["classes"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var SwitchComponent = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: '8px 0',
      overflow: 'visible'
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(16px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: "none"
        }
      },
      "&$focusVisible $thumb": {
        color: theme.palette.primary.main,
        border: "6px solid #fff"
      }
    },
    thumb: {
      width: 24,
      height: 24
    },
    track: {
      borderRadius: 26 / 2,
      border: "1px solid ".concat(theme.palette.grey[400]),
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"])
    },
    checked: {},
    focusVisible: {}
  };
})(function (_ref) {
  var classes = _ref.classes,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Switch.default, _extends({
    focusVisibleClassName: classes.focusVisible,
    disableRipple: true,
    classes: {
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked
    }
  }, props));
});
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center'
    },
    label: {
      marginRight: '0.25rem'
    }
  };
});
var CustomSwitch = function CustomSwitch(_ref2) {
  var label = _ref2.label,
    description = _ref2.description,
    checked = _ref2.checked,
    handleChange = _ref2.handleChange,
    name = _ref2.name;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    wrap: "nowrap",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.label
  }, label), !_lodash.default.isEmpty(description) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: description
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, null, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))))), /*#__PURE__*/_react.default.createElement(SwitchComponent, {
    checked: checked,
    onChange: handleChange,
    name: name
  }));
};
exports.CustomSwitch = CustomSwitch;